import React from "react";

const LinkedInIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 200 200"
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path
            fill="#0172b1"
            d="M179.84,200A20.08,20.08,0,0,0,200,180V20A20.08,20.08,0,0,0,179.84,0H20.16A20.08,20.08,0,0,0,0,20V180a20.08,20.08,0,0,0,20.16,20Z"
          />
          <path
            fill="#ffeed7"
            d="m54.86 35.55c-8.36 0-13.81 5.63-13.81 13 0 7.16 5.29 13 13.47 13 8.7 0 14-5.8 14-13-0.18-7.38-5.3-13-13.66-13z"
          />
          <rect fill="#ffeed7" x="41.73" y="71.7" width="25.92" height="83.4" />
          <path
            fill="#ffeed7"
            d="M162.31,155.1V105.81c0-24.56-12.79-36-29.85-36-14,0-22.34,8-25.75,13.47h-.51L105,71.7H82.49c.34,7.51.68,16.2.68,26.61v56.8h25.92V107a18.69,18.69,0,0,1,.85-6.48c1.88-4.77,6.14-9.72,13.3-9.72,9.38,0,13.13,7.34,13.13,18.08V155.1Z"
          />
        </g>
      </g>
    </svg>
  );
};
export default LinkedInIcon;
